import { render } from "./AclListRulesTab.vue?vue&type=template&id=9b6389ce&scoped=true"
import script from "./AclListRulesTab.vue?vue&type=script&lang=js"
export * from "./AclListRulesTab.vue?vue&type=script&lang=js"

import "./AclListRulesTab.vue?vue&type=style&index=0&id=9b6389ce&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b6389ce"]])

export default __exports__